
/* ****************
 * 選択中のレイヤーを全解除
 * ****************/
export const emptySelectedLayer = (selectedLayers: string[] | undefined): string[] | undefined => {
    if (!selectedLayers) { return undefined; }
    return [];
}

/* ****************
 * レイヤーの表示・非表示を切り替え
 * ****************/
export const toggleSelectedLayers = (selectedLayers: string[] | undefined, targetLayerIds: string[], checked: boolean): string[] => {
    
    if(checked) {
        if (!selectedLayers) { return [...targetLayerIds]; }
        return [...selectedLayers, ...targetLayerIds.filter((layer) => !selectedLayers.includes(layer))];
    } else {
        if (!selectedLayers) { return []; }
        return [...selectedLayers.filter((layer) => !targetLayerIds.includes(layer))];
    }
}
